// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__GOxdl","file":"styles_file__3m77H"};